module.exports = __webpack_public_path__ + "static/media/phone.ac52c85c.png";